<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          border="bottom"
          colored-border
          :type="itemsAccount.length == 0 ? 'warning' : 'info'"
          elevation="0"
          dense
          color="teal"
          class="shadow-small round alert-mercado-libre"
        >
          <v-row align="center" v-if="itemsAccount.length == 0">
            <v-col class="grow">
              Integrar tu cuenta de
              <strong>Mercado Libre</strong>
              <v-spacer></v-spacer>
              <span style="font-size: 13px">Recuerda que debes tener tu sesión iniciada en ML</span>
            </v-col>
            <v-col class="shrink">
              <v-btn
                v-if="itemsAccount.length == 0"
                color="warning"
                class="black--text"
                @click="MercadoLibre"
                :loading="loading"
              >Integrar</v-btn>
            </v-col>
          </v-row>
          <v-row align="center" v-else>
            <v-col class="grow">
              Tu cuenta
              <strong>{{itemsAccount[0].name}}</strong>
              ya esta integrada a
              <strong>Mercado Libre</strong>
              <v-spacer></v-spacer>
              <span style="font-size: 13px">Recuerda que debes tener tu sesión iniciada en ML</span>
            </v-col>
            <v-col class="shrink">
              <v-btn
                color="#b2aaaa"
                class="black--text"
                @click="deactivateAccount(itemsAccount[0].id)"
                :loading="loading"
              >Desactivar</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <!-- <v-col cols="12" sm="4" md="4">
                <v-container fluid class="py-0">
                    <v-data-iterator
                      :items="itemsAccount"
                      :items-per-page.sync="itemsPerPage"
                      :page="page"
                      :search="search"
                      :sort-by="sortBy.toLowerCase()"
                      :sort-desc="sortDesc"
                      hide-default-footer
      >-->
      <!-- <template v-slot:header>
                        <v-toolbar
                          dark
                          color="blue"
                          class="mb-1"
                          flat
                        >
                          <v-text-field
                            v-model="search"
                            clearable
                            filled
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            label="Buscar"
                          ></v-text-field>
                        </v-toolbar>
      </template>-->

      <!-- <template v-slot:default="props">
                        <v-row class="py-0">
                          <v-col
                            v-for="item in props.items"
                            :key="item.name"
                            cols="12"
                            class="d-flex stretch py-0"
      >-->
      <!-- <v-card class="shadow-small round" width="100%"> -->
      <!-- <v-card-title class="subheading font-weight-bold">{{ item.name }}</v-card-title> -->
      <!-- <v-card-text> -->
      <!-- <span class="py-0 font-weight-bold">{{ item.name }}</span> -->
      <!-- <v-card-subtitle
                                  :class="(item.in_activation === 1) ? 
                                          'px-0 font-weight-bold pt-1 pb-0 ml-1 teal--text' : 
                                          'px-0 font-weight-bold pt-1 pb-0 ml-1 red--text'"
      > {{ item.in_activation | status_account }}</v-card-subtitle>-->
      <!-- </v-card-text> -->

      <!-- <v-divider></v-divider> -->
      <!-- <v-card-actions>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                      :loading="loading_active"
                                      absolute
                                      dark
                                      fab
                                      bottom
                                      right
                                      small 
                                      v-bind="attrs"
                                      v-on="on"
                                      :color="(item.in_activation == 1) ? 'red' : 'teal' "> 
                                      <v-icon v-if="item.in_activation == 1" @click="deactivateAccount(item.id)">mdi-thumb-down</v-icon>
                                      <v-icon v-else @click="activeAccount(item.id)">mdi-thumb-up</v-icon>
                                    </v-btn>
                                  </template>
                                  <span v-if="item.in_activation == 1">Desactivar Cuenta</span>
                                  <span v-else>Activar Cuenta</span>
                                </v-tooltip>
      </v-card-actions>-->

      <!-- <v-list dense>
                                <v-list-item
                                  v-for="(key, index) in filteredKeys"
                                  :key="index"
                                >
                                  <v-list-item-content :class="{ 'blue--text': sortBy === key }">{{ key }}:</v-list-item-content>
                                  <v-list-item-content class="align-end" :class="{ 'blue--text': sortBy === key }">{{ item[key.toLowerCase()] }}</v-list-item-content>
                                </v-list-item>
      </v-list>-->
      <!-- </v-card>
                          </v-col>
                        </v-row>
                      </template>
      -->
      <!--  <template v-slot:footer>
                        <v-row class="mt-2" align="center" justify="center">
                          <span class="grey--text">Items per page</span>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                dark
                                text
                                color="primary"
                                class="ml-2"
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ itemsPerPage }}
                                <v-icon>mdi-chevron-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="(number, index) in itemsPerPageArray"
                                :key="index"
                                @click="updateItemsPerPage(number)"
                              >
                                <v-list-item-title>{{ number }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>

                          <v-spacer></v-spacer>

                          <span
                            class="mr-4
                            grey--text"
                          >
                            Page {{ page }} of {{ numberOfPages }}
                          </span>
                          <v-btn
                            fab
                            dark
                            color="blue darken-3"
                            class="mr-1"
                            @click="formerPage"
                          >
                            <v-icon>mdi-chevron-left</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            dark
                            color="blue darken-3"
                            class="ml-1"
                            @click="nextPage"
                          >
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-btn>
                        </v-row>
      </template>-->
      <!-- </v-data-iterator>
                  </v-container>
      </v-col>-->
    </v-row>
  </v-container>
</template>
<script>
// import axios from "axios";
import Swal from "sweetalert2";

export default {
  data: () => ({
    loading_active: false,
    loading: false,
    itemsPerPageArray: [4, 8, 12],
    search: "",
    filter: {},
    sortDesc: false,
    page: 1,
    itemsPerPage: 4,
    sortBy: "name"
  }),

  filters: {
    status_account(value) {
      if (value === 1) {
        return "Activo";
      } else {
        return "Inactivo";
      }
    }
  },

  created() {
    this.dataMercadoLibre();
  },

  mounted() {
    console.log("***", this.$route.query.code);
    if (this.$route.query.redirect == 1) {
      this.codeVerify(this.$route.query.code, this.$route.query.error);
    }
  },

  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    },
    itemsAccount() {
      return this.$store.getters["dropshipping/ITEMS_ACCOUNT"];
    }
  },

  methods: {
    async MercadoLibre() {
      try {
        this.loading = true;

        window.open(
          "http://www.mercadolibre.com/jms/mla/lgz/logout?go=https%3A%2F%2Fauth.mercadolibre.com.ar%2Fauthorization%3Fresponse_type%3Dcode%26client_id%3D7871104474817702&platform_id=ml",
          "_self"
        );

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log("error", error);
      }
    },
    async codeVerify(code, error) {
      try {
        this.loading = true;

        let request = {};

        if (error !== undefined) {
          request = {
            code: code,
            error: error
          };
        } else {
          request = {
            code: code
          };
        }

        const response = await this.$store.dispatch(
          "dropshipping/CODE_VERIFY",
          request
        );

        Swal.fire({
          title: response.data,
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        });

        this.loading = false;

        console.log("verify **", response.data);
      } catch (error) {
        this.loading = false;

        Swal.fire({
          title: error.response.data,
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        });

        console.log("error", error.response);
        // this.$emit("dialog:change", error.response);
      }
    },

    async dataMercadoLibre() {
      try {
        await this.$store.dispatch("dropshipping/INDEX");
      } catch (e) {
        // statements
        console.log(e.response);
      }
    },
    deactivateAccount(id_account) {
      console.log(id_account);
      try {
        Swal.fire({
          title: "Estas seguro que desea desactivar la cuenta ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(async result => {
          if (result.value) {
            this.loading_active = true;
            const request = {
              id: id_account
            };
            await this.$store.dispatch(
              "dropshipping/DEACTIVATE_ACCOUNT",
              request
            );
            this.loading_active = false;

            Swal.fire({
              title: "Desactivado!",
              text: "Tu cuenta ha sido dessactivada con exito",
              icon: "success",
              confirmButtonColor: "#7160ec"
            });
          }
        });
      } catch (e) {
        // statements
        console.log(e);
        this.loading_active = false;
      }
    },
    activeAccount(id_account) {
      console.log(id_account);
      try {
        // statements
        Swal.fire({
          title: "Estas seguro que desea activar la cuenta ?",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then(async result => {
          if (result.value) {
            this.loading_active = true;

            const request = {
              id: id_account
            };
            await this.$store.dispatch(
              "dropshipping/ACTIVATE_ACCOUNT",
              request
            );
            this.loading_active = false;
            Swal.fire({
              title: "Activada!",
              text: "Tu cuenta ha sido activada con exito",
              icon: "success",
              confirmButtonColor: "#7160ec"
            });
          }
        });
      } catch (e) {
        // statements
        this.loading_active = false;

        console.log(e);
      }
    }
  }
};
</script>
<style>
.alert-mercado-libre {
  /*background-color: #f1eada !important;*/
}
</style>